import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-profesionales',
  templateUrl: './profesionales.component.html',
  styleUrls: ['./profesionales.component.scss'],
  providers: [CommonService]
})
export class ProfesionalesComponent implements OnInit {
  public profesional:any;
  public profesionales:any[];

  constructor(private commonService:CommonService, private router:Router) { }

  ngOnInit() {
    this.profesional = {
      nombre:'',
      apellido:'',
      mp:'',
      email:'',
      telefono:'',
      precio:''
    };

    this.commonService.getProfesionales()
      .then(result => this.profesionales = result);
  }

  public saveProfesional(edit) {
    this.commonService
      .saveProfesional(this.profesional)
      .then(result => {
        this.profesional = {
          nombre:'',
          apellido:'',
          mp:'',
          email:'',
          telefono:'',
          precio:''
        };

        if (edit) {
          this.router.navigateByUrl("/carga/profesionales/" + result);
        } else {
          this.commonService.getProfesionales()
            .then(result => this.profesionales = result);
        }
    });
  }

  public editarProfesional(id) {
    this.router.navigateByUrl("/carga/profesionales/" + id);
    
  }
}



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/carga/profesionales/profesionales.component.ts